export const formatTelLink = (fullNumber: string) => {
  const scrubbedNumber = (fullNumber || '').replace(/[^\d\+\*#]/g, '')
  return `tel:${scrubbedNumber}`
}
